export interface TabStypeItem {
  nType: number;
  sSType: string;
  nSType: number;
  // Ajoutez ici d'autres champs selon vos besoins
}

export const tabStypeItemDefaultValue = {
  nType: 0,
  sSType: '',
  nSType: 0
}